import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card d-block" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "text-lg-right" }
const _hoisted_7 = { class: "card d-block" }
const _hoisted_8 = { class: "bordered-tab-wrap" }
const _hoisted_9 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_10 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = {
  key: 1,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_12 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_13 = {
  key: 0,
  class: "tab-pane fade show active",
  id: "member-phase",
  role: "tabpanel",
  "aria-labelledby": "member-phase-tab"
}
const _hoisted_14 = { class: "border p-3 rounded mb-3" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_22 = { class: "desc-wrap" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_27 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_28 = { class: "desc-wrap" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, [
  /*#__PURE__*/_createVNode("strong", null, "No. of days for this project")
], -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar" })
], -1)
const _hoisted_33 = { class: "desc-wrap" }
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, " Project Timeline")
], -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = { class: "border p-3 rounded mb-3" }
const _hoisted_42 = { class: "form-group mb-0" }
const _hoisted_43 = { for: "Name" }
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = { class: "border p-3 rounded mb-3" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, " Phase Timeline")
], -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createVNode("strong", null, "TBD", -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "border p-3 rounded mb-3" }
const _hoisted_54 = { class: "form-group mb-0" }
const _hoisted_55 = { for: "Desc" }
const _hoisted_56 = { class: "border p-3 rounded mb-3" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = { for: "Priority" }
const _hoisted_61 = { value: "3" }
const _hoisted_62 = { value: "2" }
const _hoisted_63 = { value: "1" }
const _hoisted_64 = { class: "col-md-3" }
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = { for: "Startdate" }
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = { for: "Startdate" }
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_71 = { class: "col-md-3" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = { for: "Enddate" }
const _hoisted_74 = /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "form-group mb-md-0" }
const _hoisted_77 = { for: "Member" }
const _hoisted_78 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status"
}
const _hoisted_79 = { class: "sr-only" }
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode()
const _hoisted_82 = {
  class: "tab-pane fade",
  id: "member-task",
  role: "tabpanel",
  "aria-labelledby": "member-task-tab"
}
const _hoisted_83 = {
  key: 0,
  class: "mb-3 bg-light p-2"
}
const _hoisted_84 = { class: "input-btn" }
const _hoisted_85 = {
  href: "javascript:void(0)",
  class: "btn default-btn"
}
const _hoisted_86 = {
  key: 1,
  class: "phase-cards-holder custom-scroll"
}
const _hoisted_87 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectWorkflowAppGoBack = _resolveComponent("ProjectWorkflowAppGoBack")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_ToDoPhaseAddMemberIndividualTest = _resolveComponent("ToDoPhaseAddMemberIndividualTest")
  const _component_ToDoPhaseAddMemberTask = _resolveComponent("ToDoPhaseAddMemberTask")
  const _component_AddMembeToTask = _resolveComponent("AddMembeToTask")
  const _component_AddMemberToTaskEditPhase = _resolveComponent("AddMemberToTaskEditPhase")
  const _component_AppDeleteConfirmationModal = _resolveComponent("AppDeleteConfirmationModal")
  const _component_CheckAvaibilityByUser = _resolveComponent("CheckAvaibilityByUser")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state.ui.isLoading.phaseDetails)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_ProjectWorkflowAppGoBack, {
                uuid: _ctx.phaseDetails.smart_contract.uuid,
                pathName: `user-todo-list`
              }, null, 8, ["uuid"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.error.errorList.phaseDetails,
          hasError: _ctx.state.ui.error.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_8, [
          _createVNode("ul", _hoisted_9, [
            (_ctx.isActive('add_member_to_phase'))
              ? (_openBlock(), _createBlock("li", _hoisted_10, [
                  _createVNode("button", {
                    class: "nav-link active",
                    id: "member-phase-tab",
                    "data-toggle": "tab",
                    "data-target": "#member-phase",
                    type: "button",
                    role: "tab",
                    "aria-controls": "member-phase",
                    "aria-selected": "true",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab('phase')))
                  }, _toDisplayString(_ctx.$t('add_member_to_phase')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isActive('add_member_to_task'))
              ? (_openBlock(), _createBlock("li", _hoisted_11, [
                  _createVNode("button", {
                    class: "nav-link",
                    id: "member-task-tab",
                    "data-toggle": "tab",
                    "data-target": "#member-task",
                    type: "button",
                    role: "tab",
                    "aria-controls": "member-task",
                    "aria-selected": "false",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab('task')))
                  }, _toDisplayString(_ctx.$t('add_member_to_task')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_12, [
            (_ctx.tabPermissionStatus)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    (
                _ctx.phaseDetails.smart_contract &&
                _ctx.phaseDetails.smart_contract.estimation &&
                _ctx.phaseDetails.smart_contract.estimation.title
              )
                      ? (_openBlock(), _createBlock("h6", _hoisted_15, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('estimation_name')) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.phaseDetails.smart_contract.estimation.title), 1)
                        ]))
                      : (_openBlock(), _createBlock("h6", _hoisted_16, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('estimation_name')) + ":", 1),
                          _hoisted_17
                        ])),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode("div", _hoisted_22, [
                            _createVNode("p", null, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('budget')), 1)
                            ]),
                            (
                        _ctx.phaseDetails &&
                        _ctx.phaseDetails.smart_contract &&
                        _ctx.phaseDetails.smart_contract.budget
                      )
                              ? (_openBlock(), _createBlock("p", _hoisted_23, " $ " + _toDisplayString(_ctx.phaseDetails.smart_contract.budget), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_24, "$ " + _toDisplayString(_ctx.$t('n_a')), 1))
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_25, [
                        _createVNode("div", _hoisted_26, [
                          _createVNode("div", _hoisted_27, [
                            _createVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createVNode("p", null, _toDisplayString(_ctx.calculateProjectTotalDays(_ctx.state.data.phases)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_30, [
                        _createVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createVNode("div", _hoisted_33, [
                            _hoisted_34,
                            (_ctx.state.data.projectTimeline.type == 4)
                              ? (_openBlock(), _createBlock("p", _hoisted_35, " TBD "))
                              : (_ctx.state.data.projectTimeline?.start_date && _ctx.state.data.projectTimeline?.end_date)
                                ? (_openBlock(), _createBlock("p", _hoisted_36, _toDisplayString(_ctx.formatDate(_ctx.state.data.projectTimeline.start_date)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.state.data.projectTimeline.end_date)) + "s ", 1))
                                : (_openBlock(), _createBlock("p", _hoisted_37, [
                                    _hoisted_38
                                  ]))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _createVNode("div", _hoisted_40, [
                      _createVNode("div", _hoisted_41, [
                        _createVNode("div", _hoisted_42, [
                          _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('name_of_phase')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "Name",
                            "aria-describedby": "Name",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.phaseDetails.phase.name = $event)),
                            disabled: _ctx.state.data.phaseDetailsStatus
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.phaseDetails.phase.name]
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _hoisted_46,
                        (_ctx.state.data.phaseTimeline.type == 4)
                          ? (_openBlock(), _createBlock("p", _hoisted_47, [
                              _hoisted_48
                            ]))
                          : (_ctx.state.data.phaseTimeline?.start_date && _ctx.state.data.phaseTimeline?.end_date)
                            ? (_openBlock(), _createBlock("p", _hoisted_49, [
                                _createVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.state.data.phaseTimeline.start_date)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.state.data.phaseTimeline.end_date)), 1)
                              ]))
                            : (_openBlock(), _createBlock("p", _hoisted_50, [
                                _hoisted_51
                              ]))
                      ])
                    ]),
                    _createVNode("div", _hoisted_52, [
                      _createVNode("div", _hoisted_53, [
                        _createVNode("div", _hoisted_54, [
                          _createVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('phase_description')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "Desc",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.phaseDetails.phase.description = $event)),
                            disabled: _ctx.state.data.phaseDetailsStatus
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.phaseDetails.phase.description]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, [
                        _createVNode("div", _hoisted_59, [
                          _createVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('phase_priority')), 1),
                          _withDirectives(_createVNode("select", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.phaseDetails.phase.priority_id = $event)),
                            disabled: _ctx.state.data.phaseDetailsStatus
                          }, [
                            _createVNode("option", _hoisted_61, _toDisplayString(_ctx.$t('high')), 1),
                            _createVNode("option", _hoisted_62, _toDisplayString(_ctx.$t('medium')), 1),
                            _createVNode("option", _hoisted_63, _toDisplayString(_ctx.$t('low')), 1)
                          ], 8, ["disabled"]), [
                            [_vModelSelect, _ctx.phaseDetails.phase.priority_id]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_64, [
                        _createVNode("div", _hoisted_65, [
                          _createVNode("label", _hoisted_66, _toDisplayString(_ctx.$t('phase_estimated_budget')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            inputmode: "decimal",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.phaseDetails.phase.edit_budget = $event)),
                            disabled: _ctx.state.data.phaseDetailsStatus
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.phaseDetails.phase.edit_budget]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_67, [
                        _createVNode("div", _hoisted_68, [
                          _createVNode("label", _hoisted_69, [
                            _createTextVNode(_toDisplayString(_ctx.$t('phase_start_date')) + " ", 1),
                            _hoisted_70
                          ]),
                          _createVNode(_component_v_date_picker, {
                            modelValue: _ctx.phaseDetails.phase.edit_start_date,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.phaseDetails.phase.edit_start_date = $event)),
                            "min-date": _ctx.state.data.minDate,
                            class: _ctx.state.data.disableDate ? 'disabled' : ''
                          }, {
                            default: _withCtx(({ inputValue, inputEvents }) => [
                              _createVNode("input", _mergeProps({
                                class: "form-control",
                                value: inputValue
                              }, _toHandlers(inputEvents), {
                                disabled: _ctx.state.data.disableDate
                              }), null, 16, ["value", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "min-date", "class"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_71, [
                        _createVNode("div", _hoisted_72, [
                          _createVNode("label", _hoisted_73, [
                            _createTextVNode(_toDisplayString(_ctx.$t('phase_end_date')) + " ", 1),
                            _hoisted_74
                          ]),
                          _createVNode(_component_v_date_picker, {
                            class: {
                      disabled: !_ctx.phaseDetails.phase.edit_start_date || _ctx.state.data.disableDate
                    },
                            modelValue: _ctx.phaseDetails.phase.edit_end_date,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.phaseDetails.phase.edit_end_date = $event)),
                            "min-date": _ctx.state.data.minDate
                          }, {
                            default: _withCtx(({ inputValue, inputEvents }) => [
                              _createVNode("input", _mergeProps({
                                disabled: !_ctx.phaseDetails.phase.edit_start_date || _ctx.state.data.disableDate,
                                class: "form-control",
                                value: inputValue
                              }, _toHandlers(inputEvents)), null, 16, ["disabled", "value"])
                            ]),
                            _: 1
                          }, 8, ["class", "modelValue", "min-date"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_75, [
                        _createVNode("div", _hoisted_76, [
                          _createVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('add_existing_member')), 1),
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.state.data.invite.existingMemberSelected,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.invite.existingMemberSelected = $event)),
                            options: _ctx.phaseDetails.members,
                            "custom-label": _ctx.nameWithEmail,
                            "close-on-select": "true",
                            "clear-on-select": true,
                            placeholder: _ctx.$t('search_and_select'),
                            "track-by": "email",
                            onSelect: _ctx.changeDetailsByEmail
                          }, null, 8, ["modelValue", "options", "custom-label", "placeholder", "onSelect"])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.state.ui.isLoading.changeDetailsByEmail)
                    ? (_openBlock(), _createBlock("div", _hoisted_78, [
                        _createVNode("span", _hoisted_79, _toDisplayString(_ctx.$t('loading1')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.state.data.invite.selectedMembers &&
              _ctx.state.data.invite.selectedMembers.length
            )
                    ? (_openBlock(), _createBlock(_component_ToDoPhaseAddMemberIndividualTest, {
                        key: 1,
                        members: _ctx.state.data.invite.selectedMembers,
                        isShowDeleteMember: true,
                        isShowDeleteSlot: false,
                        activeTab: _ctx.state.data.activeTab,
                        type: 0,
                        permissions: _ctx.phaseDetails.permissions,
                        relatedPermissions: _ctx.phaseDetails.phase_permissions,
                        amountDepends: _ctx.phaseDetails.amount_depends,
                        roles: _ctx.phaseDetails.roles,
                        userRole: _ctx.phaseDetails.phase.role_id,
                        amountTypes: _ctx.phaseDetails.amount_types,
                        onSelectedMemberIndex: _ctx.selectedMemberIndex,
                        onDeleteAmountType: _ctx.deleteAmountType,
                        onDeleteRole: _ctx.deleteRole,
                        onAddNewRole: _ctx.addNewRole,
                        onAddNewAmountType: _ctx.addNewAmountType,
                        onSelectedRoleForMember: _ctx.selectedRoleForMember,
                        onSelectedAmountTypeForMember: _ctx.selectedAmountTypeForMember,
                        onSelectedMember: _ctx.selectedMember,
                        onCheckWithRow: _ctx.checkWithRow,
                        onSelectedMemberForCheckAvaibility: _ctx.selectedMemberForCheckAvaibility
              ,
                        onMemberWisePermission: _ctx.memberWisePermission,
                        onPermissionByUser: _ctx.permissionByUser
                      }, null, 8, ["members", "activeTab", "permissions", "relatedPermissions", "amountDepends", "roles", "userRole", "amountTypes", "onSelectedMemberIndex", "onDeleteAmountType", "onDeleteRole", "onAddNewRole", "onAddNewAmountType", "onSelectedRoleForMember", "onSelectedAmountTypeForMember", "onSelectedMember", "onCheckWithRow", "onSelectedMemberForCheckAvaibility", "onMemberWisePermission", "onPermissionByUser"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_80, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn mr-2",
                      disabled: !_ctx.hasValidLastEmail,
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.insertEmptyMember && _ctx.insertEmptyMember(...args)))
                    }, _toDisplayString(_ctx.$t('add')) + " " + _toDisplayString(_ctx.$t('another_member')), 9, ["disabled"]),
                    _hoisted_81,
                    _createVNode("button", {
                      type: "submit",
                      class: "btn default-btn",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addMembersInPhases && _ctx.addMembersInPhases(...args))),
                      disabled: !_ctx.memberFilteredSlotsValid || !_ctx.phaseDetails?.phase?.edit_start_date || !_ctx.phaseDetails?.phase?.edit_end_date
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.addMembersInPhases
                    ? _ctx.$t('loading1')
                    : _ctx.$t('submit')), 9, ["disabled"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_82, [
              (!_ctx.state.data.showAddMemberModal)
                ? (_openBlock(), _createBlock("div", _hoisted_83, [
                    _createVNode("div", _hoisted_84, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('enter_phase_title_to_search'),
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.filterBySearch = $event))
                      }, null, 8, ["placeholder"]), [
                        [_vModelText, _ctx.state.data.filterBySearch]
                      ]),
                      _createVNode("a", _hoisted_85, _toDisplayString(_ctx.$t('search')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.state.data.showAddMemberModal)
                ? (_openBlock(), _createBlock("div", _hoisted_86, [
                    _createVNode("div", _hoisted_87, [
                      (_ctx.filteredPhases && _ctx.filteredPhases.length)
                        ? (_openBlock(), _createBlock(_component_ToDoPhaseAddMemberTask, {
                            key: 0,
                            tasks: _ctx.filteredPhases,
                            onShowTaskUpdateModal: _ctx.showTaskUpdateModal,
                            onSelectedTask: _ctx.selectedTask,
                            onSelectedChecked: _ctx.selectedChecked,
                            onShowAddMemberToTaskModal: _ctx.showAddMemberToTaskModal
                          }, null, 8, ["tasks", "onShowTaskUpdateModal", "onSelectedTask", "onSelectedChecked", "onShowAddMemberToTaskModal"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.showAddMemberModal)
                ? (_openBlock(), _createBlock(_component_AddMembeToTask, {
                    key: 2,
                    activeTab: _ctx.state.data.activeTab,
                    activeUserRole: _ctx.phaseDetails.phase.role_id,
                    phaseDetails: _ctx.phaseDetails,
                    isActive: _ctx.state.data.showAddMemberModal,
                    tasks: _ctx.filteredChildPhases,
                    permissions: _ctx.phaseDetails.permissions,
                    relatedPermissions: _ctx.phaseDetails.task_permissions,
                    amountDepends: _ctx.phaseDetails.amount_depends,
                    existingMembers: _ctx.phaseDetails.members,
                    roles: _ctx.phaseDetails.roles,
                    amountTypes: _ctx.phaseDetails.amount_types,
                    onHideAddMemberToTaskModal: _ctx.hideAddMemberToTaskModal,
                    onNewAmountTypeFromTaskMember: _ctx.addNewAmountType,
                    onAddMemberToTaskData: _ctx.addMemberToTaskData,
                    onAddMemberToTaskSuccess: _ctx.addMemberToTaskSuccess,
                    onNewRoleFromTaskMember: _ctx.addNewRole
                  }, null, 8, ["activeTab", "activeUserRole", "phaseDetails", "isActive", "tasks", "permissions", "relatedPermissions", "amountDepends", "existingMembers", "roles", "amountTypes", "onHideAddMemberToTaskModal", "onNewAmountTypeFromTaskMember", "onAddMemberToTaskData", "onAddMemberToTaskSuccess", "onNewRoleFromTaskMember"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showTaskUpdateModal)
        ? (_openBlock(), _createBlock(_component_AddMemberToTaskEditPhase, {
            key: 0,
            isActive: _ctx.state.data.showTaskUpdateModal,
            selectedTask: _ctx.state.data.selectedTask,
            minDate: _ctx.state.data.minDate,
            maxDate: _ctx.state.data.maxDate,
            onHideUpdateTaskModal: _ctx.hideUpdateTaskModal,
            onSetUpdatedTask: _ctx.setUpdatedTask
          }, null, 8, ["isActive", "selectedTask", "minDate", "maxDate", "onHideUpdateTaskModal", "onSetUpdatedTask"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.showDeleteConfirmationModal)
      ? (_openBlock(), _createBlock(_component_AppDeleteConfirmationModal, {
          key: 1,
          showConfirmationModal: _ctx.state.data.showDeleteConfirmationModal,
          onButtonTrigger: _ctx.removeSelectedMember,
          onHideConfirmation: _ctx.hideConfirmation,
          message: _ctx.state.data.deleteModalMessage
        }, null, 8, ["showConfirmationModal", "onButtonTrigger", "onHideConfirmation", "message"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showAvailibilityModal)
      ? (_openBlock(), _createBlock(_component_CheckAvaibilityByUser, {
          key: 2,
          startDate: _ctx.phaseDetails.phase.startDateVueCal,
          endDate: _ctx.phaseDetails.phase.endDateVueCal,
          phaseDetails: _ctx.phaseDetails,
          activeTab: _ctx.state.data.activeTab,
          isActive: _ctx.state.data.showAvailibilityModal,
          selectedEmail: _ctx.state.data.selectedEmail,
          userDetails: _ctx.state.data.selectedUser,
          onCreatedEvent: _ctx.createdEvent,
          onDeletedEvent: _ctx.deletedEvent,
          onHideAvaibilityModal: _ctx.hideAvaibilityModal
        }, null, 8, ["startDate", "endDate", "phaseDetails", "activeTab", "isActive", "selectedEmail", "userDetails", "onCreatedEvent", "onDeletedEvent", "onHideAvaibilityModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 3,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}